import cn from 'classnames';
import { FC } from 'react';

import { getInitials } from '@/shared/lib';
import { Avatar } from '@/shared/ui';

import styles from './DoctorLabel.module.scss';

type DoctorLabelProps = {
  className?: string;
  fullName?: string;
  avatarSrc?: string;
  size?: number;
};

export const DoctorLabel: FC<DoctorLabelProps> = (props) => {
  const { className, fullName, avatarSrc, size } = props;

  const doctorInitials = getInitials(fullName ?? '');

  return (
    <div className={cn(styles.container, className)}>
      <Avatar
        src={avatarSrc}
        alt={fullName}
        initials={doctorInitials}
        size={size}
      />
      <p data-ph-mask className={cn(styles.text, 'p2')}>
        {fullName}
      </p>
    </div>
  );
};
